// import { api } from "@/services/openapi"
import { Pets } from "@/gen/openapi-js/src"
import router from "@/router"

const FelcanaProApi = require("symptom_checker_api")
const defaultClient = FelcanaProApi.ApiClient.instance
const api_key = defaultClient.authentications["api_key"]
const api = new FelcanaProApi.ApiApi()

const state = () => ({
  pet: {
    id: null,
    name: null,
    species: null,
    date_of_birth: null,
    breed: null,
    profile_pic: null,
    gender: null,
    weight: null,
    weight_units: null,
  },
  pets: [],
  errors: {},
})

const mutations = {
  save(state, value) {
    state.pet[value.key] = value.value
  },
  set_species(state, payload) {
    if (payload === "dog") {
      state.pet.species = Pets.SpeciesEnum.dog
    } else if (payload === "cat") {
      state.pet.species = Pets.SpeciesEnum.cat
    }
  },
  create_profile_step_1(state, pet) {
    // regex stuff is to make sure name is capitlised. Sadly no title() in JS
    // This needs a little more work later
    state.pet.name = pet.name
      .trim()
      .toLowerCase()
      .replace(/^\w/, (c) => c.toUpperCase())
    state.pet.date_of_birth = pet.date_of_birth
  },
  create_profile_step_2(state, payload) {
    // Set Breed  and Gender(neutered vs not) for a pet.
    state.pet.breed = payload.breed
    if (payload.gender === "male" && payload.neutered === false) {
      state.pet.gender = "male"
    } else if (payload.gender === "male" && payload.neutered === true) {
      state.pet.gender = "male_neutered"
    } else if (payload.gender === "female" && payload.neutered === false) {
      state.pet.gender = "female"
    } else if (payload.gender === "female" && payload.neutered === true) {
      state.pet.gender = "female_spayed"
    }
  },
  create_profile_step_3(state, payload) {
    state.pet.weight = payload
    state.pet.weight_units = "kg"
  },
  updatePetList(state, payload) {
    state.pet = payload
    const payloadDeepClone = JSON.parse(JSON.stringify(payload))
    state.pets.push(payloadDeepClone)
  },
  setPetList(state, payload) {
    state.pets = payload
  },
  error(state, error) {
    if (typeof error === "object" && error !== null) {
      state.errors = error
    }
  },
}

const actions = {
  async fetchPetList({ commit }) {
    const token = JSON.parse(localStorage.getItem("store")).auth.token
    api_key.apiKey = token

    api
      .apiV1ScPetListList()
      .then((res) => {
        commit("setPetList", res)
      })
      .catch((err) => {
        console.log(err)
        commit("error", err.body)
      })
  },
  async create({ commit, state }) {
    await api
      .apiV1ScPetCreate(state.pet)
      .then(() => {
        this.dispatch("pet/update_pets")
      })
      .catch((err) => {
        console.log(err)
        commit("error", err.body)
      })
  },
  async delete({ commit, state }) {
    await api
      .apiV1ScPetDelete(state.pet.id)
      .then(() => {
        this.dispatch("pet/update_pets")
      })
      .catch((err) => {
        console.log(err)
        commit("error", err.body)
      })
  },
  async update({ commit, state }) {
    await api
      .apiV1ScPetPartialUpdate(state.pet.id, state.pet)
      .then(() => {
        this.dispatch("pet/update_pets")
      })
      .catch((err) => {
        console.log(err)
        commit("error", err.body)
      })
  },
  async update_pets({ commit }) {
    await api
      .apiV1ScPetListList()
      .then((res) => {
        commit("set_pets", res)
      })
      .catch((err) => {
        console.log(err)
        commit("error", err.body)
      })
  },
  async create_profile_step_1({ commit }, payload) {
    commit("create_profile_step_1", payload)
    commit("set_species", payload.species)
    await router.push({ name: process.env.VUE_APP_PET_SET_BREED })
  },
  async create_profile_step_2({ commit }, payload) {
    commit("create_profile_step_2", payload)
    await router.push({ name: process.env.VUE_APP_PET_SET_WEIGHT })
  },
  async create_profile_step_3({ commit }, payload) {
    commit("create_profile_step_3", payload)
    await router.push({ name: process.env.VUE_APP_PET_CREATE_PROFILE })
  },
  async createPetForLoggedInUser({ commit }, payload) {
    const token = JSON.parse(localStorage.getItem("store")).auth.token
    api_key.apiKey = token

    await api
      .apiV1ScPetCreate(payload)
      .then((res) => {
        commit("updatePetList", res)
      })
      .catch((err) => {
        console.log("Error in createPetForLoggedInUser", err)
        commit("error", err.body)
      })
  },
}

const getters = {
  pets: (state) => state.pets,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
